import React from "react";
import { useNavigate } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight, Truck, ShieldCheck, Clock, Star, GraduationCap } from "lucide-react";
import Hero from "../components/Hero";
import { categories, featured, restaurant, IMG } from "../mock/menuData";

const strip = [
  { icon: ShieldCheck, text: "100% Halal" },
  { icon: Truck, text: "Livraison gratuite dès 15€" },
  { icon: Clock, text: "Ouvert 7j/7 · 11h-02h" },
  { icon: Star, text: "4,2/5 · 144 avis" },
];

const Home = () => {
  const navigate = useNavigate();
  const showcase = categories.filter((c) =>
    ["sandwichs", "burgers", "tacos", "gourmets", "hummers", "bucket", "texmex", "salades"].includes(c.id)
  );

  return (
    <div className="selection-pink">
      <Hero />

      {/* strip */}
      <div className="bg-pink">
        <div className="max-w-7xl mx-auto px-4 py-3 flex flex-wrap items-center justify-center md:justify-between gap-4">
          {strip.map((s) => (
            <div key={s.text} className="flex items-center gap-2 text-white font-semibold text-sm">
              <s.icon size={18} /> {s.text}
            </div>
          ))}
        </div>
      </div>

      {/* Best of */}
      <section className="brick-bg py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-10">
            <span className="font-script text-4xl text-pink">Dévorez</span>
            <h2 className="font-display text-4xl md:text-5xl uppercase text-white mt-1">Les Best Of M.Plaisir</h2>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
            {featured.map((f) => (
              <div
                key={f.title}
                onClick={() => navigate("/carte")}
                className="group cursor-pointer bg-[#141414] rounded-2xl overflow-hidden border border-white/10 card-hover"
              >
                <div className="relative h-48 overflow-hidden">
                  <img src={f.image} alt={f.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                  <span className="absolute top-3 left-3 bg-gold text-black text-[11px] font-bold uppercase px-2.5 py-1 rounded-full">{f.tag}</span>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                  <div className="absolute bottom-3 left-4 right-4">
                    <h3 className="font-display text-xl uppercase text-white">{f.title}</h3>
                    <p className="text-white/60 text-xs">{f.subtitle}</p>
                  </div>
                </div>
                <div className="p-4 flex items-center justify-between">
                  <span className="text-gold font-bold">{f.price}</span>
                  <span className="text-pink group-hover:translate-x-1 transition-transform"><ArrowRight size={20} /></span>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-10">
            <button onClick={() => navigate("/carte")} className="bg-pink text-white font-display text-lg uppercase px-8 py-3 rounded-full btn-shine">
              Voir toute la carte
            </button>
          </div>
        </div>
      </section>

      {/* Pass Etudiant promo */}
      <section className="relative py-14 overflow-hidden" style={{ background: "linear-gradient(120deg,#c2115f,#ec1a79)" }}>
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-6 text-white">
          <div className="flex items-center gap-5">
            <div className="bg-white/15 rounded-2xl p-4"><GraduationCap size={44} /></div>
            <div>
              <h3 className="font-display text-3xl md:text-4xl uppercase">Pass Étudiant — 6€</h3>
              <p className="text-white/85">Escalope ou steak, servi de 11h à 14h. Sur présentation de la carte étudiant.</p>
            </div>
          </div>
          <button onClick={() => navigate("/carte")} className="bg-white text-pink font-display uppercase text-lg px-7 py-3 rounded-full btn-shine">
            J'en profite
          </button>
        </div>
      </section>

      {/* Categories showcase */}
      <section className="brick-bg py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-10">
            <span className="font-script text-4xl text-pink">Notre menu</span>
            <h2 className="font-display text-4xl md:text-5xl uppercase text-white mt-1">Explorez nos catégories</h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {showcase.map((c) => {
              const Ic = Icons[c.icon] || Icons.Utensils;
              return (
                <div key={c.id} onClick={() => navigate("/carte")} className="group relative h-40 rounded-2xl overflow-hidden cursor-pointer border border-white/10 card-hover">
                  <img src={c.image} alt={c.label} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-black/50 group-hover:bg-black/30 transition-colors" />
                  <div className="absolute inset-0 flex flex-col items-center justify-center text-white">
                    <Ic size={30} className="text-gold mb-2" />
                    <span className="font-display text-lg uppercase text-center px-2">{c.label}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Delivery / info */}
      <section className="py-16 bg-[#0f0f0f]">
        <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-2 gap-10 items-center">
          <div className="relative rounded-3xl overflow-hidden border-4 border-gold">
            <img src={IMG.wings1} alt="Livraison M.Plaisir" className="w-full h-72 object-cover" />
          </div>
          <div>
            <h2 className="font-display text-4xl uppercase text-white">Livré chez vous <span className="text-pink">non stop</span></h2>
            <p className="text-white/60 mt-3">
              Commandez directement en ligne, à emporter ou en livraison. Livraison <span className="text-gold font-semibold">gratuite dès {restaurant.freeDeliveryFrom}€</span>. Vous nous trouvez aussi sur vos plateformes préférées.
            </p>
            <div className="flex flex-wrap gap-3 mt-5">
              {restaurant.platforms.map((p) => (
                <span key={p} className="bg-white/10 border border-white/15 rounded-xl px-4 py-2 font-semibold text-white/90">{p}</span>
              ))}
            </div>
            <div className="mt-6 flex flex-wrap gap-4">
              <button onClick={() => navigate("/carte")} className="bg-pink text-white font-display uppercase px-7 py-3 rounded-full btn-shine">Commander</button>
              <a href={`tel:${restaurant.phone.replace(/\s/g, "")}`} className="border-2 border-white/25 text-white font-display uppercase px-7 py-3 rounded-full hover:border-gold hover:text-gold transition-colors">
                {restaurant.phone}
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
